// react
import { useState, useEffect } from "react";
import dynamic from "next/dynamic";

// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  createComment,
  updateComment,
  CREATE_COMMENT,
  UPDATE_COMMENT,
} from "~/redux/actions/comment";
import { showAppModal } from "~/redux/actions/app";

// views
import { Button, Form } from "antd";
import Loading from "~/components/site/Loading";

const Editor = dynamic({
  loader: () => import("~/components/forms/Editor"),
  loading: () => <Loading />,
  ssr: false,
});

// utils
import { onInputChange } from "~/utils/form";

const SUBMIT_TEXT = {
  create: "发布评论",
  update: "更新评论",
  reply: "回复评论",
};

const CommentForm = (props) => {
  let contentInput = null;
  const { postId, parentId, comment, title, mode = "create" } = props;
  const content = comment ? comment.content : "";
  const raw_content = comment && comment.raw_content ? comment.raw_content : "";
  const [state, setState] = useState({
    content_reset: "",
    content: content,
    content_init: raw_content,
  });

  // props
  const disabled =
    props.request[CREATE_COMMENT] || props.request[UPDATE_COMMENT];
  const submitText = SUBMIT_TEXT[mode];

  // handles
  const handleInputChange = onInputChange({ state, setState });
  const requireSignin = () => {
    if (!props.token) {
      props.showAppModal("PhoneSigninModal");
      contentInput && contentInput.blur();
      return true;
    } else {
      return false;
    }
  };
  const handleSubmit = () => {
    if (requireSignin()) {
      return;
    }

    const commentParams = {
      postId: postId,
      parentId: parentId,
      content: state.content,
      raw_content: state.raw_content,
    };
    if (mode === "update") {
      props.updateComment(
        props.token,
        {
          ...commentParams,
          id: comment.id,
        },
        () => {
          handleCancel();
        }
      );
    } else {
      // props.createComment(
      //   props.token,
      //   {
      //     ...commentParams,
      //   },
      //   (comment) => {
      //     handleCancel();
      //     setTimeout(() => {
      //       const el = document.querySelector(`#comment-${comment.id}`);
      //       if (el && el.scrollIntoView) {
      //         el.scrollIntoView({ behavior: "smooth" });
      //       }
      //     }, 500);
      //   }
      // );

      const myEle = props.user.ele;
      if (myEle >= 0) {
        props.createComment(
          props.token,
          {
            ...commentParams,
          },
          (comment) => {
            handleCancel();
            setTimeout(() => {
              const el = document.querySelector(`#comment-${comment.id}`);
              if (el && el.scrollIntoView) {
                el.scrollIntoView({ behavior: "smooth" });
              }
            }, 500);
          }
        );
      } else {
        props.showAppModal("RestrictedOperationModal");
      }
    }
  };

  const handleContentChange = (value) => {
    setState({
      ...state,
      content: value.html,
      raw_content: value.text,
    });
  };

  const handleCancel = () => {
    setState({
      // ...state,
      content: "",
      content_init: "",
      raw_content: "",
      content_reset: new Date(),
    });

    props.onCancel && props.onCancel();
  };

  useEffect(() => {
    if (mode !== "create") {
      contentInput && contentInput.focus();
    }
  }, []);

  const cancelButton = (
    <Button disabled={disabled} onClick={handleCancel}>
      取消
    </Button>
  );

  return (
    <Form onFinish={handleSubmit}>
      <Form.Item style={{ marginBottom: 15 }}>
        <Editor
          defaultValue={state.content_init}
          reset={state.content_reset}
          token={props.token}
          title={title}
          onChange={handleContentChange}
          placeholder={`
[注 意]
    有价值的评论会得到大家的点赞支持；
    请勿通过评论暴露联系方式，不符则删；
    评论被删后，会扣除相应的电量和经验。
          `}
          height={150}
        />
      </Form.Item>

      <Button
        type="primary"
        htmlType="submit"
        className="mb-10 mr-10"
        disabled={disabled}
      >
        {submitText}
      </Button>
      {mode !== "create" && cancelButton}
    </Form>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  user: state.user.user,
  request: state.app.request,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createComment,
      updateComment,
      showAppModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CommentForm);
